const DEFAULT_PAGE_SIZES = [5, 10, 25, 50];

export default function PaginationToolbar({
  page,
  totalPages,
  pageSize,
  onPageChange,
  onPageSizeChange,
  disabled = false,
  className = "",
  pageSizes = DEFAULT_PAGE_SIZES
}) {
  const safeTotalPages = totalPages || 1;

  return (
    <div className={`card mb-3 ${className}`.trim()}>
      <div className="card-body pagination-toolbar">
        <div className="pagination-size-control">
          <label className="form-label mb-0">Registros por pagina:</label>
          <select
            className="form-select"
            value={pageSize}
            onChange={(e) => onPageSizeChange(Number(e.target.value))}
          >
            {pageSizes.map((size) => (
              <option key={size} value={size}>{size}</option>
            ))}
          </select>
        </div>
        <div className="pagination-page-control">
          <span>Pagina {page} de {safeTotalPages}</span>
          <button
            className="btn btn-sm btn-outline-secondary"
            type="button"
            onClick={() => onPageChange(Math.max(1, page - 1))}
            disabled={disabled || page === 1}
          >
            Anterior
          </button>
          <button
            className="btn btn-sm btn-outline-secondary"
            type="button"
            onClick={() => onPageChange(Math.min(totalPages, page + 1))}
            disabled={disabled || page === totalPages || totalPages === 0}
          >
            Siguiente
          </button>
        </div>
      </div>
    </div>
  );
}
